import React, { useRef, useEffect } from 'react';
import {
  Row,
  Button,
  Typography,
  Divider,
  Avatar,
  // message as Message,
} from 'antd';
import moment from 'moment';
import i18n from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import { orderAcceptedModalHandler } from './OrderAccepted';
import { RefuseOrderHandler } from './RefuseOrder';

import { Orders } from '../../../store/orders/types';
import { acceptOrRefuseOrder } from '../../../store/orders/actions';

import { getAppGlobalState } from '../../../store/app-globals/selectors';
import { GlobalModalHandler, GlobalModalClose } from '../../layout/GlobalModal';

import DASHED_LIST from '../../../assets/images/png/dashed-list.png';
import HAND from '../../../assets/images/png/hand.png';

interface AcceptOrderProps {
  meal: Orders;
  history: any;
}

export const AcceptOrder = ({ meal, history }: AcceptOrderProps) => {
  const { isLoading, message, hasError } = useSelector(getAppGlobalState);
  const isSendingReport = useRef(false);
  const dispatch = useDispatch();
  const userdetails = {
    ...meal.userdetails,
  };
  const hours = moment(meal.consumptiondate?.seconds * 1000).format('HH');

  const minutes = moment(meal.consumptiondate?.seconds * 1000).format('mm');

  const handleAcceptButton = () => {
    dispatch(acceptOrRefuseOrder(meal.id, 'accepted', '', meal.userdetails.id));
    isSendingReport.current = true;
  };

  const handleRefuseButton = () => {
    const orderid = meal.id;
    GlobalModalClose();
    RefuseOrderHandler({ orderid: orderid, guestid: meal.userdetails.id });
  };

  const acceptingOrders = () => {
    if (isSendingReport.current && !isLoading && !hasError) {
      GlobalModalClose();
      orderAcceptedModalHandler(userdetails);
    }
    if (isSendingReport.current && !isLoading && hasError) {
      // Message.error('Somwething went wrong');
      GlobalModalClose();
      orderAcceptedModalHandler(userdetails);
    }
  };

  const handleGotoProfile = () => {
    GlobalModalClose();
    history.push({
      pathname: '/userprofile/profile',
      state: userdetails,
    });
  };

  useEffect(acceptingOrders, [isLoading]);
  // console.log(history);
  return (
    <div>
      <div className="modal-content-wrapper">
        <img src={DASHED_LIST} alt="dashed list" />
        <div className="order-title">{meal.title}</div>

        <div className="order-details">
          <div onClick={handleGotoProfile} style={{ cursor: 'pointer' }}>
            <Avatar src={meal.userdetails.image} size="small" />
            <span>{meal.userdetails.firstName}</span>
          </div>
          <div className="order-content-description">{meal.portions}x</div>
          <div className="order-content-description">{meal.description}</div>
        </div>
        <Row justify="space-between" className="consumption-container">
          <Row className="takeaway-container">
            <img src={HAND} alt="hand" />
            <span>{i18n.t(meal.consumption)}</span>
          </Row>
          <div>
            <span>
              {i18n.t('TODAY')}
              <span
                style={{
                  fontSize: '16px',
                  fontWeight: 'bold',
                  color: 'black',
                  marginLeft: '10px',
                }}
              >
                {`${hours}:${minutes}`}
              </span>
            </span>
          </div>
        </Row>
      </div>
      <Divider />
      <div className="modal-content-wrapper">
        <Row justify="space-between" className="price-container">
          <div>{i18n.t('Total Price')}</div>
          <Typography.Text>{`Kč ${meal.mealprice}`}</Typography.Text>
        </Row>
        <Row justify="space-between" className="price-container">
          <div>{i18n.t('Your Payout')}</div>
          <Typography.Title
            level={4}
          >{`Kč ${meal.ordertotal}`}</Typography.Title>
        </Row>

        <Button
          block
          type="primary"
          shape="round"
          className="continue-button continue-button-primary"
          loading={isLoading}
          onClick={handleAcceptButton}
        >
          <span className="accept-button-text">
            {i18n.t(`${message}`) || i18n.t('ACCEPT')}
          </span>
        </Button>
        <Button
          block
          shape="round"
          className="cancel-button cancel-button-primary"
          onClick={handleRefuseButton}
        >
          <span className="continue-button-text">{i18n.t('Refused')}</span>
        </Button>
      </div>
    </div>
  );
};

export const AcceptOrderHandler = (meal: Orders, history: any) => {
  GlobalModalHandler({
    content: <AcceptOrder meal={meal} history={history} />,
  });
};
